import { Component, Input } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ViewModelProperty } from '../../models';
import { MatList } from '@angular/material/list';
import { MatAccordion } from '@angular/material/expansion';

import { VMPFormGroupComponent } from '../vmp-form-group/vmp-form-group.component';

@Component({
  selector: 'ldw-settings-form',
  templateUrl: './settings-form.component.html',
  styleUrls: ['./settings-form.component.css'],
  imports: [ReactiveFormsModule, MatList, MatAccordion, VMPFormGroupComponent]
})
export class SettingsFormComponent {
  form: UntypedFormGroup = new UntypedFormGroup({});

  @Input() captionWidth = 230;
  @Input() valueWidth = 600;
  @Input() settings: Array<Array<ViewModelProperty>> = [];
}
